import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import resources from './slices/resourcesSlice'
import adminDashboard from './slices/adminDashboardSlice'
import members from './slices/membersSlice'
import claims from './slices/claimsSlice'
import plans from './slices/plansSlice'
import subscriptions from './slices/subscriptionsSlice'
import collections from './slices/collectionsSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        resources,
        adminDashboard,
        members,
        claims,
        plans,
        subscriptions,
        collections,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
